import { Documento } from './documento';
import { DetallePago } from './detalle-pago';
import { Cliente } from './cliente';
import { DocumentAgregar } from './document-agregar';

export class PaymentWrapper {
    public tipo: number;
    public usuarioEsAdmin: boolean;
    public idUsuario: number;
    public cliente: Cliente;
    public ventas: Documento[] = [];
    public ventaUnica?: DocumentAgregar;
    public fechaPago: Date;
    public total: number;
    public totalCobrado: number;
    public cambio: number;
    public detallesPago: DetallePago[] = [];
    public toCashOut: number;
    public seAgregaSaldoAFavor: boolean;
    public organizationId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/payment-wrapper.ts